/**
 * Styled components for ChatInnerWithHistory
 */

import styled from 'styled-components';

export const ChatWithHistoryContainer = styled.div`
    min-width: 1px;
    min-height: 0;
    gap: 8px !important;
    flex-direction: column;
    height: 100%;
    width: 100%;
    display: flex;
`;

export const ChatSessionWrapper = styled.div`
    min-height: 1px;
    min-width: 1px;
    align-items: stretch;
    height: 100%;
    gap: 8px !important;
    flex-grow: 1;
    width: 100%;
    display: flex;
`;

export const ChatInnerWrapper = styled.div`
    flex: 1 1;
`;

